"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A simple function chain that pipes the result of the last function to the next function. Since custom operators are impossible, the `pipe` function instead uses `.chain` and `.value`.
 * Note that the functions are executed as they're chained, not when the value is retrieved.
 */
function pipe(val) {
    return {
        chain: function (fn) { return pipe(fn(val)); },
        value: function () { return val; }
    };
}
exports.pipe = pipe;
//# sourceMappingURL=pipe.js.map